import "./custom-toast.css";
import { Icon } from "components/elements/icons/icon";
import React from "react";

export function CustomToast(props) {
  function closeAlert() {
    props.clearToast();
  }

  switch (props.type) {
    case "error":
      return (
        <div className="error-toast-container">
          <div className="error-toast">
            <div className="p-grid">
              <div className="p-col-2">
                <div
                  className="icon-container cursor-pointer"
                  onClick={closeAlert}
                >
                  <Icon icon="circular-cancel" />
                </div>
              </div>
              <div className="p-col-8">
                <div className="error-toast-text-container">
                  <p className="error-toast-text-title">{props.title}</p>
                  <p className="notification-text"> {props.description}</p>
                </div>
              </div>
              <div className="p-col-2">
                {props?.closable ? (
                  <div className="icon-container-cancel">
                    <Icon icon="cancel" />
                  </div>
                ) : (
                  <div />
                )}
              </div>
            </div>
          </div>
        </div>
      );
    case "success":
      return (
        <div className="error-toast-container">
          <div className="success-toast">
            <div className="p-grid">
              <div className="p-col-2">
                <div
                  className="icon-container-success cursor-pointer"
                  onClick={closeAlert}
                >
                  <Icon icon="circular-success" />
                </div>
              </div>
              <div className="p-col-8">
                <div className="error-toast-text-container">
                  <p className="success-toast-text-title">{props.title}</p>
                  <p className="notification-text">{props.description}</p>
                </div>
              </div>
              <div className="p-col-2">
                <div className="icon-container-cancel">
                  <Icon icon="cancel-success" />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    default:
      return <div></div>;
  }
}
